import LoaderSpin from 'snippets/loader-spin/loader-spin'

function ButtonATC ({ text, onHandle, price, loading, disabled = false, buttonClass = '' }) {
  const classCustom = `relative w-full uppercase button-primary button-large py-[18px] ${!disabled ? '' : 'text-grey-400'} ${buttonClass}`

  return (
    <button type='button' className={classCustom} disabled={disabled} onClick={() => onHandle()}>
      {loading
        ? (
          <LoaderSpin wrapperClass='bg-black' />
          )
        : (
          <>
            {text}
          </>
          )}
    </button>
  )
}

export default ButtonATC
